// helper to know if we should limit data. This exists in our main script, it is here so we can get access earlier
let limitNetwork = ( () => {
	if (
		!navigator
		|| !navigator.connection
		|| !navigator.connection.effectiveType
	) {
		return null;
	}

	if ( navigator.connection.saveData === true ) {
		return true
	}

	switch ( navigator.connection.effectiveType ) {
		case '3g':
		case '4g':
			return false;
			break
		default:
			return true;
	}

} )();

// check if they want low motion, again also in our main script, here for speed
const preferslowmotion = window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches;

function heroVideo(el, settings) {
	//.hero-media
	// 	.herovideo <- this.wrapperEl
	// 		figure.wp-block-video <- this.videoWrapperEl
	// 			video <- this.videoEl
	// 				track
	// 		button <- this.buttonEL
	// 			svg
		
	let currentVideo = null;
	let canAutoPlay = false;
	let playing = false;
	let videoEl = el.querySelector('video');
	const loop = settings.video.loop;
	let playpauseEl = null;
	let playEl = null;
	let muteEl = null;
	let fullscreenEl = null;
	let topButtonWrapper = null;
	const wrapperEl = el;
	const videoWrapperEl = el.querySelector('figure');
	const resizeObserver = new ResizeObserver(swapVideo);

	const createTopButtonWrapper = () => {
		topButtonWrapper = document.createElement('div');
		topButtonWrapper.setAttribute('class', 'top-button-wrapper');
		wrapperEl.appendChild(topButtonWrapper);
	}

	const handleMuteStatus = () => {
		muteEl.setAttribute('aria-pressed', videoEl.muted ? 'true' : 'false');
		if (videoEl.muted) {
			muteEl.setAttribute('aria-label', 'Unmute video');
			muteEl.innerHTML = '<svg version="1.1" viewBox="0 0 752 752" xmlns="http://www.w3.org/2000/svg"><use xlink:href="#unmute"></use></svg>';
		} else {
			muteEl.setAttribute('aria-label', 'Mute video');
			muteEl.innerHTML = '<svg version="1.1" viewBox="0 0 752 752" xmlns="http://www.w3.org/2000/svg"><use xlink:href="#mute"></use></svg>';
		}
	}

	const createPlayPauseButtonEl = () => {

		// add our play/pause button
		playpauseEl = document.createElement('button');
		playpauseEl.setAttribute('class', 'playpause-btn');
		playpauseEl.setAttribute('aria-label', `${canAutoPlay ? "Play decorative background video" : "Play video"}`);
		playpauseEl.setAttribute('aria-pressed', 'false');

		playpauseEl.addEventListener('click', e => {
			playPause();
		});

		playpauseEl.innerHTML = '<svg version="1.1" viewBox="0 0 752 752" xmlns="http://www.w3.org/2000/svg"><use xlink:href="#playpause"></use></svg>';
		topButtonWrapper.appendChild(playpauseEl);
	}

	const createMuteButtonEl = () => {
		muteEl = document.createElement('button');
		muteEl.setAttribute('class', 'mute-btn');
		handleMuteStatus();

		muteEl.addEventListener('click', e => {
			mute();
		})

		topButtonWrapper.appendChild(muteEl);
	}

	const createFullScreenBtnEL = () => {
		fullscreenEl = document.createElement('button');
		fullscreenEl.setAttribute('class', 'fs-btn');
		fullscreenEl.setAttribute('aria-label', 'Expand the video to fullscreen');
		fullscreenEl.setAttribute('aria-pressed', 'false');

		fullscreenEl.addEventListener('click', e => {
			fullScreen();
		})

		fullscreenEl.innerHTML = '<svg version="1.1" viewBox="0 0 752 752" xmlns="http://www.w3.org/2000/svg"><use xlink:href="#fullscreen"></use></svg>';
		topButtonWrapper.appendChild(fullscreenEl);
	}
	
	const createPlayButtonEL = () => {

		// only do this if there is no play button yet.
		if (wrapperEl.querySelector('.play-btn')) {
			return;
		}

		// add our play/pause button
		playEl = document.createElement('button');
		playEl.setAttribute('class', 'play-btn');
		playEl.setAttribute('aria-label', 'Play video');
		playEl.setAttribute('aria-pressed', 'false');

		playEl.addEventListener('click', e => {
			playPause();
			createTopButtonWrapper();
			createPlayPauseButtonEl();
			if (settings.video.showAudioControl) {
				createMuteButtonEl();
			}
			if (settings.video.showFullscreenControl) {
				createFullScreenBtnEL();
			}
			// remove any play buttons
			const playBtns = wrapperEl.querySelectorAll('.play-btn');
			[].forEach.call(playBtns, el => el.remove());
		});

		playEl.innerHTML = '<svg version="1.1" viewBox="0 0 752 752" xmlns="http://www.w3.org/2000/svg"><use xlink:href="#play"></use></svg>';
		wrapperEl.appendChild(playEl);
	}

	const createReplayBtn = e => {

		// only do this if there is no replay button yet.
		if (wrapperEl.querySelector('.replay-btn')) {
			return;
		}

		playEl = document.createElement('button');
		playEl.setAttribute('class', 'replay-btn');
		playEl.setAttribute('aria-label', 'Replay video');
		playEl.setAttribute('aria-pressed', 'false');

		playEl.addEventListener('click', e => {
			playPause();
			// remove any play buttons
			const replayBtns = wrapperEl.querySelectorAll('.replay-btn');
			[].forEach.call(replayBtns, el => el.remove());
		});

		playEl.innerHTML = '<svg version="1.1" viewBox="0 0 752 752" xmlns="http://www.w3.org/2000/svg"><use xlink:href="#play"></use></svg>';
		wrapperEl.appendChild(playEl);
	}

	// Can we autoplay?
	if (!preferslowmotion && !limitNetwork && settings.video.autoplay) {
		canAutoPlay = true;
		playing = true;
	}

	// createVideoEl();
	if (canAutoPlay) {
		createTopButtonWrapper();
		createPlayPauseButtonEl();	
		if (settings.video.showAudioControl) {
			createMuteButtonEl();
		}
		if (settings.video.showFullscreenControl) {
			createFullScreenBtnEL();
		}
	} else {
		createPlayButtonEL();
	}
	
	resizeObserver.observe(wrapperEl);



	
	if (canAutoPlay) {
		const urlParams = new URLSearchParams(window.location.search);
		const myParam = urlParams.get('delay');
		if( myParam ){
			setTimeout(() => {
				play();
			}, myParam * 1000);
		} else {
			videoEl.autoplay = true;
		}

	}


	function getVideoSettings() {
		switch (true) {
			case (!settings.video.mobile || !settings.video.mobile.src || settings.video.mobile.src == ''):
				return settings.video.desktop;
				break;
			case (!settings.video.desktop || !settings.video.desktop.src || settings.video.desktop.src == ''):
				return settings.video.mobile;
				break;
			default:
				return (window.visualViewport.width < 768) ? settings.video.mobile : settings.video.desktop;
		}
	}

	function createVideoEl() {
		currentVideo = getVideoSettings();

		// make the video el 
		videoEl = document.createElement('video');
		videoEl.loop = loop;
		videoEl.muted = canAutoPlay ? true : false;
		videoEl.playsinline = true;
		videoEl.setAttribute('preload', 'none');
		videoEl.setAttribute('role', 'presentation');
		videoEl.setAttribute('aria-hidden', true);
		
		videoEl.src = currentVideo.src;
		videoEl.setAttribute('type', 'video/mp4');

		if (currentVideo.poster) {
			videoEl.poster = currentVideo.poster;
		}

		createTracks();

		// clear out anything that was there.
		videoWrapperEl.innerHTML = '';

		// attach our new video
		videoWrapperEl.appendChild(videoEl);
	}

	function createTracks() {
		videoEl.innerHTML = '';

		if (currentVideo && currentVideo.tracks.length > 0) {
			
			currentVideo.tracks.forEach(track => {
				if (!track.src || !track.lang || !track.label || !track.kind) return;

				const trackEl = document.createElement('track');
				trackEl.src = track.src;
				trackEl.srclang = track.lang;
				trackEl.label = track.label;
				trackEl.kind = track.kind;
				videoEl.appendChild(trackEl);
			});
		}
	}

	

	function swapVideo() {
		let maybeDifferentVideo = getVideoSettings();

		// if the video does not match the current one then swap them.
		if (maybeDifferentVideo != currentVideo) {

			// if the current video is at some point, store its time for later
			if (videoEl.currentTime) {
				currentVideo.currentTime = videoEl.currentTime;
			}

			// update the current video to the correct settings
			currentVideo = maybeDifferentVideo;

			// change the video source & poster
			videoEl.setAttribute('src', currentVideo.src);
			if ( preferslowmotion && currentVideo.poster) {
			 	videoEl.setAttribute('poster', currentVideo.poster);
			}

			// if the now current video had a stored time, jump to that
			if (currentVideo.currentTime) {
				videoEl.currentTime = currentVideo.currentTime;
			}

			// build any tracks
			createTracks();

			// was the video playing?
			if (playing) {
				videoEl.play();
			}
		}
	}

	function play() {
		playing = true;
		videoEl.play();
	}

	function pause() {
		playing = false;
		videoEl.pause();
		playpauseEl.setAttribute('aria-pressed', 'false');
	}

	function mute() {
		videoEl.muted = !videoEl.muted;
		handleMuteStatus();
	}
	
	function fullScreen() {
		if (videoEl.requestFullscreen) {
			videoEl.requestFullscreen();
		} else if (videoEl.mozRequestFullScreen) {
			videoEl.mozRequestFullScreen();
		} else if (videoEl.webkitRequestFullscreen) {
			videoEl.webkitRequestFullscreen();
		} else if (videoEl.msRequestFullscreen) {
			videoEl.msRequestFullscreen();
		} else if (videoEl.webkitEnterFullscreen) {
			// ios
			videoEl.webkitEnterFullscreen();
		}
	}

	function playPause() {
		if (playing) {
			pause();
		} else {
			play();
		}
	}

	// events
	videoEl.addEventListener('ended', e => {
		playing = false;
		createReplayBtn();
	});
}

// Usage
var hv = heroVideo( document.querySelector( ".herovideo" ), heroData );
